export const isEmail = (value: any): boolean => {
  if (!value || typeof value !== 'string') {
    return false;
  }

  const trimmed = value.trim();

  const emailRegex = /^(?!\.)(?!.*\.\.)(?!.*\.$)[A-Za-z0-9_%+\-]+(?:\.[A-Za-z0-9_%+\-]+)*@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return emailRegex.test(trimmed);
};
